<template>
  <button v-if="updateExists" class="btn btn-update-exists" @click="refreshApp">
    <strong>New version available!</strong>
    <br />
    Click to update
  </button>
</template>

<script>
export default {
  name: 'UpdateExists',
  data() {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
    };
  },

  created() {
    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true });
    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload(true);
    });
  },
  methods: {
    showRefreshUI(e) {
      // Display a button inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      this.registration = e.detail;
      this.updateExists = true;
    },
    refreshApp() {
      // Handle a user tap on the update app button.
      this.updateExists = false;
      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage('skipWaiting');
    },
  },
};
</script>
<style lang="sass" scoped>
.btn-update-exists
  background-color: #67c23a
  position: fixed
  top: 1em
  width: 220px
  right: calc( 50% - 110px )
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1)
  transition: all .5s ease
  &:hover
    transform: scale(1.1)
</style>
